import React, { createContext, ReactNode, useState } from "react";

interface ISettings {
    division: string;
    ghat: string;
    ghatName: string;
    displayName: 'main' | 'dock';
    dockNo: string;
    header1FontSize: string;
    header2FontSize: string;
    tableBodyFontSize: string;
    splitIndex: number;
    slideInDuration: number;
    apiCallFrequency: number;
    languageToggleInterval: number;
    displayTextList: string[];
}

interface ISettingsContext {
    settings: ISettings;
    setSettings: React.Dispatch<React.SetStateAction<ISettings>>;
}

const initialSettingsState: ISettings = {
    division: '',
    ghat: '',
    ghatName: '',
    dockNo: '',
    displayName: 'main',
    header1FontSize: '40',
    header2FontSize: '36',
    tableBodyFontSize: '24',
    splitIndex: 4,
    slideInDuration: 8,
    apiCallFrequency: 60,
    languageToggleInterval: 4,
    displayTextList: []
};

const SettingsContext = createContext<ISettingsContext>({
    settings: initialSettingsState,
    setSettings: () => { },
});

interface SettingsProviderProps {
    children: ReactNode;
}

export const SettingsProvider: React.FC<SettingsProviderProps> = ({ children }) => {
    const [settings, setSettings] = useState<ISettings>(initialSettingsState);

    return (
        <SettingsContext.Provider value={{ settings, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};

export default SettingsContext;
